import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import './deps';
import { TEMPLATE, UPLOAD, SIGN } from './icons';
import './index.less';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import { useModal } from '@ebay/nice-modal-react';
import FilePreview from '@/components/EmailEditorQuill/FilePreview';
import { createPortal } from 'react-dom';
import { uploadFile } from '@/services/api';
import styles from './index.module.less';
import { fullPath } from '@/utils/utils';
import { optionList } from './option';
import { useContainer } from '../LibProvider';
import { QuoteIcon } from '@/components/SvgIcon';
import { useUpdate } from 'ahooks';
import isQuoteEle from './utils';
import { SETTING_MENUS } from '@/constant';
import { useTranslation } from 'react-i18next';
import EmailSendAction from './SendAction';
let editorKey = 0;
const EmailEditor = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { templateDisable, fileDisable, subjectDisable, height = 300, onSubjectChange, onSend, splitFile, readOnly, defaultValue, hideSendBtn, disableQuote, disableSign, isNewMail, signObj, isAddTemplate, imgArrList, showSign = true, onChange, type, defaultSendTime, isScheduledTask } = props;
    const update = useUpdate();
    const container = useContainer();
    const signSubject = useAppSelector((state)=>state.signConfig.currentSignInfo);
    const templateModal = useModal('EmailTemplate');
    const editor = useRef(null);
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const fileInput = useRef(null);
    const [value, setValue] = useState(defaultValue);
    const [floating, setFloating] = useState(false);
    const [editorClass] = useState(()=>{
        return `editor-${editorKey++}`;
    });
    const { t } = useTranslation();
    let quote = useAppSelector((state)=>state.editor.quote);
    if (disableQuote) {
        quote = '';
    }
    const isRelay = useAppSelector((state)=>state.editor.isRelay);
    const quoteRef = useRef(quote);
    const dispatch = useAppDispatch();
    let disabled = subjectDisable || files.length === 0 && value === '';
    const [expand, setExpand] = useState(true);
    const expandRef = useRef(expand);
    expandRef.current = expand;
    const signText = (signSubject === null || signSubject === void 0 ? void 0 : signSubject.status) == 1 && !!(signSubject === null || signSubject === void 0 ? void 0 : signSubject.content);
    const settingAction = useSettingAction();
    const [sendTime] = useState(defaultSendTime);
    // useEffect(() => {
    // 	if (type === 'update' && quote) {
    // 		setExpand(false)
    // 	}
    // }, [type, quote])
    const getFileUrls = async (param)=>{
        let { upload } = param;
        const attachments = [];
        const size = files.reduce((size, file)=>size + file.size, 0);
        let mergedFiles = [];
        let annexList = [];
        // > 10M 才上传
        const exceed = size / 1024 / 1024 > 10;
        const uploadFlag = upload && !exceed || !upload && exceed;
        /**
		 * 转发邮件需要带上附件,先获取到原附件
		 * 如果没有新增,跳过上传附件步骤,直接给到转发接口字段
		 * 如果有新增,只上传新增的图片文件
		 * 合并原有的附件和新上传的附件
		 */ if (uploadFlag) {
            // @ts-ignore
            const filesList = files.filter((item)=>!item.file_name);
            for (const file of filesList){
                const formData = new FormData();
                formData.append('file', file);
                const result = await uploadFile(formData);
                attachments.push({
                    url: result,
                    file_name: file.name
                });
            }
        }
        if ((imgArrList === null || imgArrList === void 0 ? void 0 : imgArrList.length) > 0) {
            annexList = imgArrList === null || imgArrList === void 0 ? void 0 : imgArrList.map((item)=>{
                return {
                    url: item.url,
                    file_name: item.file_name
                };
            });
        }
        mergedFiles = [
            ...attachments,
            ...annexList
        ];
        if (annexList) {
            return mergedFiles;
        } else {
            return attachments;
        }
    };
    const getCustomContents = async ()=>{
        const attachments = await getFileUrls({
            upload: !splitFile
        });
        if (!value) {
            message.warning(t('c_e_email_empty_content'));
            return;
        }
        // 转发邮件---不需要在html内容中带附件
        if (isRelay) {
            return `${value}`;
        } else {
            let newContext = expand ? `${value}${quote}` : `${value}`;
            return `${newContext}${attachments.length > 0 ? ` <p>Attach files:</p>${attachments.map((item, index)=>`<p><a href=${item.url} download target="_blank">${item.file_name || `file${index}`}</a></p>`).join('')}
        ` : ''}`;
        }
    };
    const send = async (params)=>{
        setLoading(true);
        try {
            if (params === null || params === void 0 ? void 0 : params.resolve) {
            // TODO
            }
            const finalSendTime = (params === null || params === void 0 ? void 0 : params.send_time) ?? sendTime;
            await onSend(await getCustomContents(), await getFileUrls({
                upload: !!splitFile
            }), (params === null || params === void 0 ? void 0 : params.resolve) ? 1 : 0, finalSendTime, type);
            setLoading(false);
        } finally{
            setLoading(false);
        }
    };
    useImperativeHandle(ref, ()=>({
            // @ts-ignore
            getContent () {
                return value;
            },
            clean () {
                var _editor_current_editor, _editor_current;
                (_editor_current = editor.current) === null || _editor_current === void 0 ? void 0 : (_editor_current_editor = _editor_current.editor) === null || _editor_current_editor === void 0 ? void 0 : _editor_current_editor.resetContent('');
                setFiles([]);
            }
        }));
    const firstRef = useRef(true);
    const editorStateKey = useAppSelector((state)=>state.editor.key);
    let editorState = useAppSelector((state)=>{
        const editor = state.editor;
        return [
            editor.subject,
            editor.content,
            editor.quote,
            editor.aiReply,
            editor.isAI,
            editor.isRelay,
            editor.imgList
        ];
    });
    useEffect(()=>{
        if (firstRef.current) {
            return;
        }
        // @ts-ignore
        onChange === null || onChange === void 0 ? void 0 : onChange({
            value,
            files
        });
    }, [
        value,
        files
    ]);
    useEffect(()=>{
        if (firstRef.current) {
            firstRef.current = false;
            return;
        }
    }, [
        editorStateKey
    ]);
    useEffect(()=>{
        if (isNewMail) {
            let timer = setTimeout(()=>{
                var _editor_current;
                const status = signSubject === null || signSubject === void 0 ? void 0 : signSubject.status;
                const text = signSubject === null || signSubject === void 0 ? void 0 : signSubject.content;
                const isEditor = editor.current && editor.current.editor;
                const editorRef = editor === null || editor === void 0 ? void 0 : (_editor_current = editor.current) === null || _editor_current === void 0 ? void 0 : _editor_current.editor;
                if (isEditor && status == 1 && text !== '') {
                    editorRef === null || editorRef === void 0 ? void 0 : editorRef.execCommand('mceInsertContent', false, `<p></p><p></p><p></p><div class="signature">${text}</div>`);
                }
                // @ts-ignore  光标移动到最前面
                editorRef.selection.setCursorLocation(tinymce.activeEditor.getBody(), 0);
                clearTimeout(timer);
            }, 1000);
            // 新邮件清掉历史存入的数据
            dispatch(updateEditorContent({
                subject: '',
                content: '',
                img: null,
                insertType: 1,
                quote: ' '
            }));
        }
    }, [
        isNewMail
    ]);
    const quoteWrap = container.querySelector(`.${editorClass} .tox-toolbar-overlord .tox-toolbar:first-child`);
    const usingSignatures = (e)=>{
        var _editor_current, _tinymce;
        let isEditor = editor.current && editor.current.editor;
        let editorRef = editor === null || editor === void 0 ? void 0 : (_editor_current = editor.current) === null || _editor_current === void 0 ? void 0 : _editor_current.editor;
        let div = document.createElement('div');
        // @ts-ignore
        div.innerHTML = (_tinymce = tinymce) === null || _tinymce === void 0 ? void 0 : _tinymce.activeEditor.getContent();
        let isMark = div.querySelector('.signature');
        if (e.id == 1) {
            var // @ts-ignore
            _tinymce_activeEditor, _tinymce1;
            if (isMark && !isQuoteEle(isMark)) isMark.remove();
            (_tinymce1 = tinymce) === null || _tinymce1 === void 0 ? void 0 : (_tinymce_activeEditor = _tinymce1.activeEditor) === null || _tinymce_activeEditor === void 0 ? void 0 : _tinymce_activeEditor.setContent(div.innerHTML);
            // @ts-ignore
            // tinymce.activeEditor.execCommand('SelectAll') // 选中所有文本
            // @ts-ignore
            // tinymce.activeEditor.selection.collapse(false) // 将光标移动到最后
            editorRef.selection.setCursorLocation(tinymce.activeEditor.getBody(), 0); // 将光标移动到最前
        } else if (e.id == 2 && isEditor) {
            if (isMark && isQuoteEle(isMark) && signText || !isMark) {
                const signText = (signSubject === null || signSubject === void 0 ? void 0 : signSubject.content) !== undefined && (signSubject === null || signSubject === void 0 ? void 0 : signSubject.content) !== '';
                if (signText) {
                    // 插入签名
                    editorRef === null || editorRef === void 0 ? void 0 : editorRef.execCommand('mceInsertContent', false, `<p></p><p></p><div class="signature">${signSubject === null || signSubject === void 0 ? void 0 : signSubject.content}</div>`);
                    setFloating(false);
                    // @ts-ignore  光标移动到签名的最前面
                    editorRef.selection.setCursorLocation(tinymce.activeEditor.getBody(), 0);
                } else {
                    ManageSignatures();
                }
            }
        } else {
            ManageSignatures();
        }
        setFloating(false);
    };
    // 管理签名
    const ManageSignatures = ()=>{
        settingAction.openSetting(SETTING_MENUS.ACCOUNT_SIGNATURES);
    };
    useEffect(()=>{
        if (!editor.current) return;
        const ed = editor.current.editor;
        const syncValue = ()=>{
            const content = ed === null || ed === void 0 ? void 0 : ed.getContent();
            if (content !== value) {
                setValue(content);
            }
        };
        /** 监听编辑器的change或keyup */ ed === null || ed === void 0 ? void 0 : ed.on('NodeChange', syncValue);
        ed === null || ed === void 0 ? void 0 : ed.on('KeyUp', syncValue);
        /** 万一有 execCommand 插入内容，不触发上面的事件，再用定时器兜底 */ const timer = setInterval(syncValue, 200);
        return ()=>{
            ed === null || ed === void 0 ? void 0 : ed.off('NodeChange', syncValue);
            ed === null || ed === void 0 ? void 0 : ed.off('KeyUp', syncValue);
            clearInterval(timer);
        };
    }, [
        editor,
        value
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames(editorClass, 'bg-white relative', styles['email-editor'], hideSendBtn && styles['no-send']),
        style: {
            height: `${height + files.length * 40}px`,
            transition: 'height .2s ease-out'
        },
        children: [
            /*#__PURE__*/ _jsx(Editor, {
                ref: editor,
                licenseKey: "gpl",
                toolbar: [
                    '',
                    `bold strikethrough fontsizeselect italic bullist underline${fileDisable ? '' : ' upload'} ${disableSign ? '' : 'sign'} ${templateDisable ? '' : ' template'}`
                ],
                plugins: "lists",
                init: {
                    height: '100%',
                    menubar: false,
                    toolbar_location: 'bottom',
                    statusbar: false,
                    setup (editor) {
                        editor.ui.registry.addIcon('icon-upload', UPLOAD);
                        editor.ui.registry.addIcon('icon-sign', SIGN);
                        editor.ui.registry.addIcon('icon-template', TEMPLATE);
                        // editor.ui.registry.addIcon('icon-polish', POLISH)
                        editor.ui.registry.addButton('upload', {
                            icon: 'icon-upload',
                            tooltip: 'Attach files',
                            onAction () {
                                var _fileInput_current;
                                (_fileInput_current = fileInput.current) === null || _fileInput_current === void 0 ? void 0 : _fileInput_current.click();
                            },
                            onSetup (oapi) {
                                return (iapi)=>{
                                    console.log(oapi, iapi);
                                };
                            }
                        });
                        // 签名tool
                        showSign && editor.ui.registry.addButton('sign', {
                            icon: 'icon-sign',
                            onAction: function() {
                                setFloating((floating)=>!floating);
                            },
                            tooltip: 'Signature'
                        });
                        editor.ui.registry.addButton('template', {
                            icon: 'icon-template',
                            tooltip: 'Templates',
                            onAction () {
                                templateModal.show({
                                    onInsert (data) {
                                        const status = signSubject === null || signSubject === void 0 ? void 0 : signSubject.status // 签名状态
                                        ;
                                        const text = signSubject === null || signSubject === void 0 ? void 0 : signSubject.content // 签名内容
                                        ;
                                        // editor.setContent(`${data.content}<br/>`)
                                        const quote = quoteRef.current;
                                        const expand = expandRef.current;
                                        if (status == 1 && text) {
                                            editor.setContent(`${data.content}<p></p><div class="signature">${text}</div>${!expand ? `<div>${quote}</div>` : ''}`);
                                        }
                                        if (status == 0 && text) {
                                            editor.setContent(`${data.content}<br/>${!expand ? `<div>${quote}</div>` : ''}`);
                                        }
                                        if (!status && !text) {
                                            editor.setContent(`${data.content}<br/>${!expand ? `<div>${quote}</div>` : ''}`);
                                        }
                                        const [subject] = editorState;
                                        const subjectText = isNewMail ? data.subject : subject;
                                        onSubjectChange === null || onSubjectChange === void 0 ? void 0 : onSubjectChange(subjectText);
                                    }
                                });
                            }
                        });
                    },
                    content_css: fullPath('tinymce.content.css'),
                    // eslint-disable-next-line complexity
                    init_instance_callback (editor) {
                        // 非新建发送邮件和新增模版邮件
                        if (!isNewMail && isAddTemplate) {
                            const [subject, content, quote, aiReply, isAI, isRelay, imgList] = editorState;
                            const signStatusON = (signSubject === null || signSubject === void 0 ? void 0 : signSubject.status) == 1 && !!(signSubject === null || signSubject === void 0 ? void 0 : signSubject.content);
                            const signStatusOFF = (signSubject === null || signSubject === void 0 ? void 0 : signSubject.status) == 0 && !!(signSubject === null || signSubject === void 0 ? void 0 : signSubject.content);
                            onSubjectChange === null || onSubjectChange === void 0 ? void 0 : onSubjectChange(subject);
                            // AI快捷回复,签名开启
                            if (aiReply && signStatusON) {
                                editor === null || editor === void 0 ? void 0 : editor.setContent(`${aiReply}<p></p><p></p><div class="signature">${signObj === null || signObj === void 0 ? void 0 : signObj.content}</div>`);
                            }
                            // AI快捷回复,签名关闭
                            if (aiReply && signStatusOFF) {
                                editor === null || editor === void 0 ? void 0 : editor.setContent(`${aiReply}</br>`);
                            }
                            // 普通回复,签名开启
                            if (signStatusON && !aiReply) {
                                editor === null || editor === void 0 ? void 0 : editor.setContent(`<p></p><p></p><div class="signature">${signObj === null || signObj === void 0 ? void 0 : signObj.content}</div>`);
                            }
                            // 签名为空,AI回复
                            if (!signStatusON && !signStatusOFF && aiReply) {
                                editor === null || editor === void 0 ? void 0 : editor.setContent(`${aiReply}</br>`);
                            }
                            // 转发邮件,签名开启
                            if (isRelay && signStatusON) {
                                setFiles(imgList);
                                editor === null || editor === void 0 ? void 0 : editor.setContent(`</p></p><div class="signature">${signObj === null || signObj === void 0 ? void 0 : signObj.content}</div><p/>${content}${quote}`);
                            }
                            // 转发邮件,签名关闭
                            if (isRelay && signStatusOFF) {
                                setFiles(imgList);
                                editor === null || editor === void 0 ? void 0 : editor.setContent(`</p></p><div>${content}${quote}</div>`);
                            }
                            // 转发邮件,签名为空
                            if (isRelay && !signStatusOFF && !signStatusON) {
                                setFiles(imgList);
                                editor === null || editor === void 0 ? void 0 : editor.setContent(`</p></p><div>${content}${quote}</div>`);
                            }
                            update();
                        }
                    },
                    async images_upload_handler (file) {
                        const blob = file.blob();
                        const formData = new FormData();
                        formData.append('file', blob);
                        const res = await uploadFile(formData);
                        return res;
                    }
                },
                disabled: readOnly,
                initialValue: defaultValue,
                onEditorChange: (value)=>{
                    setValue(value);
                }
            }),
            floating && /*#__PURE__*/ _jsx("div", {
                className: styles['floating'],
                children: optionList.map((item)=>{
                    return /*#__PURE__*/ _jsx("div", {
                        onClick: ()=>usingSignatures(item),
                        children: item.label
                    }, item.id);
                })
            }),
            !hideSendBtn && /*#__PURE__*/ _jsx(EmailSendAction, {
                loading: loading,
                disabled: disabled,
                send: send,
                isNewMail: isNewMail,
                type: type,
                sendTime: defaultSendTime,
                isScheduledTask: isScheduledTask
            }),
            /*#__PURE__*/ _jsx("input", {
                className: "!hidden",
                type: "file",
                ref: fileInput,
                value: "",
                onChange: (event)=>{
                    const files = event.target.files;
                    if (files && files.length > 0) {
                        setFiles((fileList)=>fileList.concat(files[0]));
                    }
                }
            }),
            quote && expand && // 展开的状态
            quoteWrap && // 已经获取到了结构
            // !disableQuote &&
            isAddTemplate && !isNewMail && // 不是弹窗新邮件
            !isRelay && // 不是转发邮件
            /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx(Tooltip, {
                title: "Show trimmed content",
                children: /*#__PURE__*/ _jsx("span", {
                    onClick: ()=>{
                        var _tinymce, _editor_current_editor, _editor_current;
                        const [subject, content, quote] = editorState;
                        let fillContent;
                        let div = document.createElement('div');
                        // @ts-ignore
                        div.innerHTML = (_tinymce = tinymce) === null || _tinymce === void 0 ? void 0 : _tinymce.activeEditor.getContent();
                        let isMark = div.querySelector('.signature');
                        if (signText && !isMark) {
                            fillContent = `<div class="signature">${signSubject.content}</div><br${quote}`;
                        }
                        // if (signText && value) {
                        // 	fillContent = `${value}<br/>${quote}`
                        // }
                        if (signText || value) {
                            fillContent = `${value}<br/>${quote}`;
                        } else {
                            fillContent = `<br/><br/>${quote}`;
                        }
                        (_editor_current = editor.current) === null || _editor_current === void 0 ? void 0 : (_editor_current_editor = _editor_current.editor) === null || _editor_current_editor === void 0 ? void 0 : _editor_current_editor.setContent(`${fillContent}`);
                        setExpand(!expand);
                    },
                    style: {
                        marginLeft: 8,
                        cursor: 'pointer'
                    },
                    children: QuoteIcon
                })
            }), container.querySelector(`.${editorClass} .tox-toolbar-overlord .tox-toolbar:first-child`)),
            files.length > 0 && /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsx("div", {
                className: classNames('flex flex-wrap gap-[8px] mb-[16px] !w-full !px-2.5'),
                children: files.map((file, index)=>/*#__PURE__*/ _jsx("div", {
                        style: {
                            width: 'calc(50% - 4px)'
                        },
                        children: /*#__PURE__*/ _jsx(FilePreview, {
                            file: file,
                            onRemove: ()=>{
                                setFiles((files)=>files.filter((f)=>f !== file));
                            }
                        })
                    }, index))
            }), container.querySelector(`.${editorClass} .tox-toolbar-overlord .tox-toolbar:first-child`))
        ]
    });
});
export default EmailEditor;
